/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addSkill} from '../api'

export const useMutationAddSkill = createReactQueryMutationHook('addSkill', addSkill)
